import { MaterialType } from "../../types/materials";
import { TagColors } from "../forms/elements/tags/types";
import { MaterialOption, otherMaterial } from "../forms/forms-fields/materials-form-fields";

export const materialsMap: Record<
  string,
  { tagColor: TagColors; label: "materia" | "wood" | "glass" | "stone" | "metal" }
> = {
  "Advanced materials": {
    tagColor: TagColors.Materia,
    label: "materia",
  },
  Wood: {
    tagColor: TagColors.Wood,
    label: "wood",
  },
  Glass: {
    tagColor: TagColors.Glass,
    label: "glass",
  },
  Stone: {
    tagColor: TagColors.Stone,
    label: "stone",
  },
  Metal: {
    tagColor: TagColors.Metal,
    label: "metal",
  },
} as const;

export const materialsMapReverse: Record<MaterialOption, { tagColor: TagColors; label: string }> = {
  [MaterialType.Materia]: { tagColor: TagColors.Materia, label: "Advanced materials" },
  [MaterialType.Wood]: { tagColor: TagColors.Wood, label: "Wood" },
  [MaterialType.Glass]: { tagColor: TagColors.Glass, label: "Glass" },
  [MaterialType.Stone]: { tagColor: TagColors.Stone, label: "Stone" },
  [MaterialType.Metal]: { tagColor: TagColors.Metal, label: "Metal" },
  [otherMaterial]: { tagColor: TagColors.Neutral, label: "Other" },
} as const;
